<template>
	<div>
		<button :class="sfondoStyle" @click="closeMenu"></button>
		<nav :class="menuStyle">
			<ul>
				<li>
					<router-link to="/">
						Rutti Migliori
					</router-link>
				</li>
				<li>
					<router-link to="/ruttirecenti">
						Rutti Recenti
					</router-link>
				</li>
				<li>
					<hr />
				</li>
				<li>
					<router-link to="/aggiungirutto">
						Aggiungi un rutto
					</router-link>
				</li>
				<li>
					<hr />
				</li>
				<li>
					<router-link to="/info">
						Maggiori informazioni
					</router-link>
				</li>
				<li>
					<router-link to="/cookie-policy">
						Cookie Policy
					</router-link>
				</li>
			</ul>
		</nav>
	</div>
</template>
<script>
	export default {
		name: 'listLayout',
		/*
		data () {
			return {
				opened:false
			}
		},
		*/
		props:{
			open:{
				default:false,
			}
		},
		computed:{
			menuStyle: function(){
				if(this.open){
					return "menu opened"
				}
				return "menu"
			},
			sfondoStyle: function(){
				if(this.open){
					return "menuSfondo opened"
				}
				return "menuSfondo"
			}
		},
		methods:{
			openMenu: function(){
				if(this.opened){
					this.open = false;
				}else{
					this.open = true;
				}
			},
			closeMenu: function(){
				// this.open = false;
				this.$root.closeMenu();
			}
		}
	}
</script>
<style lang="less">
	.menuSfondo{
		display: none;
		position: fixed;
		top:0;
		left: 0;
		width:100%;
		height:100vh;
		border:none;
		background-color:rgba(0,0,0,.37);
		z-index:8;
		&.opened{
			@media(max-width:800px){
				display:block;
			}
		}
	}
	nav.menu{
		position: fixed;
		top: 0;
		left:0;
		text-align: left;
		padding-top: 80px;
		width:250px;
		height:100vh;
		box-sizing: border-box;
		z-index:9;
		@media(max-width:800px){
			background-color:#DDD;
			box-shadow: 0 3px 15px rgba(0,0,0,.64);
			transform:translateX(-350px);
			transition: transform .25s linear;
			&.opened{
				transform:translateX(0);
			}
		}
		ul{
			padding:0;
			margin:0;
			li{
				display:block;
				padding-top:2px;
				padding-bottom:2px;
				a{
					display:block;
					padding-left:25px;
					padding-right:25px;
					padding-top:8px;
					padding-bottom:8px;
					text-decoration: none !important;
					color:rgba(0,0,0,.50);
					transition: all .1s linear;
					@media(min-width:800px){
						border-top-right-radius: 50px;
						border-bottom-right-radius: 50px;
					}
				}
				.router-link-exact-active{
					// color:red;
					// background-color: #DDD;
					// background-color: rgba(0,0,0,.5);
					// color:white;
					background-color:white;
					color: black;
				}
				hr{
					border-style: dotted;
					border-width: 0;
					border-top-width: 1px;
					border-color: rgba(0,0,0,.15);
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// menu.vue?75bad21f